import useEffectOnce from '@app/hooks/useEffectOnce'
import track, { AnalyticsEventName } from '@app/utils/analytics'
import { Alert, AlertLink } from '@lokalise/louis'
import type { FC } from 'react'

type OtaUsageAboveThresholdAlertProps = {
	usageLimit: number
	threshold: number
	percentageUsage: number
	totalTrafficInGiBs: number
	onClose: () => void
}

const OtaUsageAboveThresholdAlert: FC<OtaUsageAboveThresholdAlertProps> = ({
	usageLimit,
	percentageUsage,
	threshold,
	totalTrafficInGiBs,
	onClose,
}) => {
	const currentDate = new Date()
	const daysInCurrentMonth = new Date(
		currentDate.getFullYear(),
		currentDate.getMonth() + 1,
		0,
	).getDate()
	const message = `You've reached ${totalTrafficInGiBs.toFixed(2)} GB of your ${usageLimit} GB OTA data allowance.`
	const eventProperties = {
		message,
		gb_limit: usageLimit,
		threshold,
		spent_traffic_percentage: Math.ceil(percentageUsage),
		spent_month_percentage: Math.ceil((currentDate.getDate() / daysInCurrentMonth) * 100),
	}

	useEffectOnce(() => {
		track(AnalyticsEventName.BANNER_DISPLAYED, eventProperties)
	})

	return (
		<Alert data-testid="otaUsageAboveThresholdAlert" status="warning" onClose={onClose}>
			{`${message} See `}
			<AlertLink
				href="https://docs.lokalise.com/en/articles/6583798-ota-pricing-faq"
				target="_blank"
			>
				OTA pricing FAQ.
			</AlertLink>
		</Alert>
	)
}

export default OtaUsageAboveThresholdAlert
